import styled from "styled-components";

export const OptionsPanel = styled.div`
  display: flex;
`;

export const OptionItem = styled.div<{ selected?: boolean }>`
  display: flex;
  flex: 1 0;
  width: 20%;
  flex-direction: column;
  margin: 0 1px;
  padding: 5px 0px 5px 0px;
  align-items: center;
  cursor: pointer;
  font-size: 13px;
  border-radius: 0.1rem;
  background-color: ${(props) =>
    props.selected ? props.theme.smalt : props.theme.pillBackground};
  color: ${(props) => (props.selected ? props.theme.white : props.theme.black)};
`;

export const ChartPanel = styled.div`
  width: 100%;
  height: 250px;
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 20px;
`;

export const StatsInfoPanel = styled.div`
  font-size: 13px;
  margin: 0px 17px 10px 17px;
  display: flex;
  justify-content: space-between;
`;

export const StatsInfoTitle = styled.div`
  margin-bottom: 5px;
`;

export const SwitchPanel = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    font-size: 10px;
  }

  img {
    margin-right: 8px;
  }
`;

export const ChartLegend = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-bottom: -25px;
  font-size: 13px;
  font-weight: bold;
`;

export const ChartToolTip = styled.div<{ isGreen?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: bold;
  background-color: ${(props) => props.theme.smalt};
  color: ${(props) => props.theme.white};
  padding: 5px 10px;
  border-radius: 4px;

  span {
    color: ${(props) =>
    props.isGreen ? props.theme.formWin : props.theme.formLoss};
  }
`;